import styled, { keyframes } from 'styled-components';

const dotPulse = keyframes`
  0%   { r:0; opacity: 0; }
  15%  { r:16.5; opacity: 1; }
  50%, 100% { r:6.5; opacity: 0; }
`;

const ripplePulse = keyframes`
  0%   { r: 0;  opacity: 0; }
  10%  { opacity: 0.2; }
  55%, 100% { r: 70; opacity: 0; }
`;

const Styled = styled.svg`
  height: 160px;
  width: 160px;
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .dot {
    r: 0;
    fill: #000000;
    animation: ${dotPulse} 3s cubic-bezier(0.21, -0.21, 0.89, 0.81) infinite;
  }

  .ripple {
    r: 0;
    stroke: #000000;
    fill: rgba(0, 0, 0, 0.1);
    animation: ${ripplePulse} 3s ease-out infinite;
  }

  .d0 {
    animation-delay: 0s;
  }
  .d1 {
    animation-delay: 0.3s;
  }
  .d2 {
    animation-delay: 0.5s;
  }
  .d3 {
    animation-delay: 0.7s;
  }
  .d4 {
    animation-delay: 0.9s;
  }
  .d5 {
    animation-delay: 1.1s;
  }
  .d6 {
    animation-delay: 1.3s;
  }

  .r0 {
    animation-delay: 0s;
  }
  .r1 {
    animation-delay: 0.4s;
  }
  .r2 {
    animation-delay: 0.6s;
  }
  .r3 {
    animation-delay: 0.8s;
  }
  .r4 {
    animation-delay: 1s;
  }
  .r5 {
    animation-delay: 1.2s;
  }
  .r6 {
    animation-delay: 1.4s;
  }
`;

const Dots = () => (
  <Styled viewBox="0 0 380 380">
    <g fill="none" id="dots-wrapper">
      <circle className="dot d6" cx="74" cy="128" r="16.5" />
      <circle className="ripple r6" cx="74" cy="128" r="16.5" />
      <circle className="dot d5" cx="74" cy="253" r="16.5" />
      <circle className="ripple r5" cx="74" cy="253" r="16.5" />
      <circle className="dot d4" cx="191" cy="313.5" r="16.5" />
      <circle className="ripple r4" cx="191" cy="313.5" r="16.5" />
      <circle className="dot d3" cx="307" cy="253" r="16.5" />
      <circle className="ripple r3" cx="307" cy="253" r="16.5" />
      <circle className="dot d2" cx="307" cy="128" r="16.5" />
      <circle className="ripple r2" cx="307" cy="128" r="16.5" />
      <circle className="dot d1" cx="191" cy="67" r="16.5" />
      <circle className="ripple r1" cx="191" cy="67" r="16.5" />
      <circle className="dot d0" cx="191" cy="190" r="16.5" />
      <circle className="ripple r0" cx="191" cy="190" r="16.5" />
    </g>
  </Styled>
);

const Loading = () => <Dots />;

export default Loading;
